/**
 * Simple localStorage wrapper for persisting calculator preferences
 */

/**
 * Get a value from localStorage
 * @param key - Storage key
 * @param defaultValue - Default value if key doesn't exist
 * @returns The stored value or defaultValue
 */
export async function getStorageItem<T>(key: string, defaultValue: T): Promise<T> {
  try {
    const item = localStorage.getItem(key);
    if (item === null) {
      return defaultValue;
    }
    return JSON.parse(item) as T;
  } catch (error) {
    console.warn(`[Storage] Failed to get item "${key}":`, error);
    return defaultValue;
  }
}

/**
 * Set a value in localStorage
 * @param key - Storage key
 * @param value - Value to store
 */
export async function setStorageItem<T>(key: string, value: T): Promise<void> {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`[Storage] Failed to set item "${key}":`, error);
  }
}
